import React from "react";

const HRDVFaq = ({ title, faqs }) => {
  return (
    <section className="hrdv-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="hrdv-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="hrdv-faq-item">
              <p className="hrdv-faq-q">{faq.q}</p>
              <p className="hrdv-faq-a">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HRDVFaq;
